
export class FitanalyticsButtonObserver {

	constructor( containerEl ) {
		this.containerEl = containerEl;
		this.fitanalyticsButtonSelector = '.fitanalytics__button';
		this.fitanalyticsButton = false;

		this.observe();
	}

	observe() {
		this.watchForButtonAdd();
		this.watchForButtonChange();
	}

	watchForButtonAdd() {
		const observer = new MutationObserver( ( mutations_list ) => {
			mutations_list.forEach( ( mutation ) => {
				mutation.addedNodes.forEach( ( added_node ) => {
					if( mutation.type === 'childList' && added_node && added_node.nodeType === 1 && added_node.classList.contains( this.fitanalyticsButtonSelector.slice( 1 ) ) ) {
						this.fitanalyticsButton = added_node;
						this.fitanalyticsButton.dispatchEvent( new CustomEvent( 'fitanalytics_button_added.acl', { bubbles: true } ) );
					}
				} );

				if ( this.fitanalyticsButton ) {
					if ( mutation.type === 'attributes' && mutation.attributeName === 'style' && window.getComputedStyle( this.fitanalyticsButton ).getPropertyValue( 'display' ) !== 'none' ) {
						this.fitanalyticsButton.dispatchEvent( new CustomEvent( 'fitanalytics_button_visible.acl', { bubbles: true } ) );
					}
				}
			} );
		} );

		observer.observe( this.containerEl, { subtree: true, childList: true, attributeFilter: ['style'] } );
	}

	watchForButtonChange() {
		const observer = new MutationObserver( ( mutations_list ) => {
			mutations_list.forEach( ( mutation ) => {
				if( mutation.type === 'attributes' && mutation.target.classList.contains( this.fitanalyticsButtonSelector.slice(1) ) ) {
					const regexCheck = new RegExp('^Unsere Empfehlung: Größe ');

					if( regexCheck.test( mutation.target.getAttribute('aria-label') ) ) {
						this.fitanalyticsButton.dispatchEvent( new CustomEvent( 'fitanalytics_button_changed.acl', { bubbles: true } ) );
					}
				}
			} );
		} );

		observer.observe( this.containerEl, { subtree: true, attributes: true, attributeFilter: ['aria-label'], attributeOldValue: true } );
	}
}

export function initFitanalyticsButtonObserver( containerEl ) {
	if ( containerEl ) {
		containerEl.ACL_FITANALYTICS_BUTTON_OBSERVER ??= new FitanalyticsButtonObserver( containerEl );
	}
}

// Override Fitanalytics functions to allow additional event trigger.
const overrideFitAnalytics = function() {
	const shop = window._fitAnalytics && window._fitAnalytics.shop;
	if ( shop ) {
		const fns = [ 'onPageLoaded', 'onProductChange', 'onProductLoaded' ];
		fns.forEach( function( func ) {
			const oldFn = shop[ func ];
			shop[ func ] = function() {
				oldFn();
				// Dispatch Custom Event after load.
				window.dispatchEvent( new CustomEvent( 'fitanalytics.acl', { detail: { action: func } } ) );
			}
		})
	}
};

// Expose to get taken up by fitanalytics pdp script.
window.overrideFitAnalytics = overrideFitAnalytics;

document.addEventListener( 'finished_change_variant', ( ev ) => {
	const containerEl = ev.target;
	initFitanalyticsButtonObserver( containerEl );
} );
